import { render, staticRenderFns } from "./Login-supplier.vue?vue&type=template&id=65b41978&scoped=true"
import script from "./Login-supplier.vue?vue&type=script&lang=js"
export * from "./Login-supplier.vue?vue&type=script&lang=js"
import style0 from "./Login-supplier.vue?vue&type=style&index=0&id=65b41978&prod&lang=scss"
import style1 from "./Login-supplier.vue?vue&type=style&index=1&id=65b41978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b41978",
  null
  
)

export default component.exports